<template>
  <div class="column">
    <div class="row justify-end">
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" outline @click.native="exportList()">{{$t('processes.export')}}</q-btn>
      </div>
      <div class="col col-auto q-pa-sm q-gutter-sm">
        <q-btn color="process" size="sm" :to="{ name: 'suivi-de-periode-probatoire-form' }" icon-right="add_circle">{{$t('processes.create_suivi_de_periode_probatoire')}}</q-btn>
      </div>
    </div>
    <q-table flat wrap-cells
      :data="preiodeProbatoireProcesses"
      :columns="columns"
      row-key="id"
      :rows-per-page-options="rowsPerPageOptions"
      :pagination.sync="pagination"
      :loading="loading"
      :filter="filter"
      @request="onRequest"
      binary-state-sort>
      <q-tr slot="body" slot-scope="props" :props="props"
        @click.native="$router.push({ name: props.row.statut === 'MANDAT_FERME' ? 'suivi-de-mandat-ferme-form' : 'suivi-de-periode-probatoire-form', params: { id: props.row.id } })"
        class="cursor-pointer">
        <q-td v-for="col in props.cols" :key="col.name" :props="props" :auto-width="col.autoWidth">
          <div v-if="col.value" v-html="col.value" />
        </q-td>
      </q-tr>
    </q-table>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import download from 'downloadjs'

export default {
  name: 'SuiviDePeriodeProbatoireList',

  preFetch ({ store, currentRoute, previousRoute, redirect, ssrContext }) {
    store.dispatch('processes/fetchFilters', 'periodeProbatoire')
  },

  meta () {
    return {
      title: 'Suivi de periode probatoire'
    }
  },

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters({
      preiodeProbatoireProcesses: 'processes/getProcesses',
      filters: 'processes/getFilters',
      rowsPerPageOptions: 'config/getRowsPerPageOptions'
    }),
    pagination: {
      ...mapGetters({ get: 'processes/getPagination' }),
      ...mapMutations({ set: 'processes/setPagination' })
    },
    filter () {
      return this.$route.meta.filter
    },
    columns () {
      console.log(this.preiodeProbatoireProcesses, this.filters)
      if (this.preiodeProbatoireProcesses.length === 0) return []
      else {
        const fields = ['agents', 'date_nomination', 'date_fin', 'decision_dir_comm', 'statut']
        const sortable = ['date_nomination', 'date_fin']

        return fields.map(key => {
          let label = this.$t(`processes.fields.${key}.label`)
          let align = 'left'
          let autoWidth = false
          let formatFn = val => val

          if (key === 'agents') {
            label = this.$t(`processes.fields.agentList.label`)
            formatFn = val => val ? val.map(agent => agent.TITULAIRE).join(', ') : ''
          } else if (key === 'date_fin') {
            label = this.$t(`processes.fields.date_fin_periode_probatoire.label`)
            formatFn = val => this.$formatDate(val)
          } else if (key === 'date_nomination') {
            formatFn = val => this.$formatDate(val)
          } else if (key === 'decision_dir_comm') {
            label = this.$t(`processes.fields.titularisation.label`)
            formatFn = val => val ? this.$t(`processes.titularisations.${val}`) : ''
          } else if (key === 'statut') {
            formatFn = val => val ? this.$t(`processes.status.${val}`) : ''
            align = 'center'
          }

          return {
            name: key,
            align: align,
            label: label,
            field: key,
            format: formatFn,
            sortable: sortable.indexOf(key) >= 0,
            autoWidth: autoWidth
          }
        })
      }
    }
  },

  watch: {
    filters: {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    },
    '$route.meta.filter': {
      handler (newVal, oldVal) {
        this.onRequest({ pagination: this.pagination })
      },
      deep: true
    }
  },

  mounted () {
    if (this.filters) {
      this.onRequest({ pagination: this.pagination })
    }
    this.$store.commit('pages/setBreadcrumbs', [
      { label: this.$t('global.home'), to: { name: 'home' } },
      { label: this.$t('processes.processAgence'), to: { name: '' } },
      { label: this.$t('processes.title.suivi_de_periode_probatoire'), to: { name: 'suivi-de-periode-probatoire-en-cours' } },
      {}
    ])

    this.$store.commit('pages/setPageTitle', this.$t('processes.title.suivi_de_periode_probatoire'))
    this.$store.commit('pages/setTabs', [
      { name: 'suivi-de-periode-probatoire-en-cours', label: 'En cours', to: { name: 'suivi-de-periode-probatoire-en-cours' } },
      { name: 'suivi-de-periode-probatoire-archivés', label: 'Archivés', to: { name: 'suivi-de-periode-probatoire-archives' } }
    ])
  },

  methods: {
    onRequest ({ pagination, filter }) {
      this.$store.commit('processes/setPagination', pagination)
      this.loading = true

      let params = { ...pagination, filter: this.filter, typeProcess: 'periodeProbatoire' }
      if (this.filters) this.filters.forEach(filter => { params[filter.id] = filter.value })

      this.$store.dispatch('processes/fetchProcesses', params)
        .finally(() => { this.loading = false })
    },

    exportList () {
      this.$axios.get('/api/processAgences/periodeProbatoire/export', {
        responseType: 'arraybuffer',
        headers: { 'Content-Type': 'text/csv' }
      }).then(response => {
        download(response.data, 'periodeProbatoire.csv')
      }).catch(this.$notifyError)
    }
  }
}
</script>
